module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-04-15 at 18.47.44 (4).jpeg";